<template>
    <div class="new-question">
        <label for="new-list-question-input">{{ $t('assignment.new_multiple_choice') }}</label>
        <b-form-group
            class="new-list-question"
            label=""
            label-for="">
            <b-input-group class="new-question-group">
                <b-form-input
                    class="new-question"
                    id="new-list-question-input"
                    v-model="title"></b-form-input>
                <b-input-group-append>
                    <b-button
                        class="btn-add btn-add-list-question"
                        variant="primary"
                        @click="addItem()"
                        :disabled="!title">
                    </b-button>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>
    </div>
</template>

<script>
export default {
    name: 'design-2021-lesson-module-assignment-type-assignment-part-list-question-component',
    props: {
        partIn: Object,
    },
    data() {
        return {
            title: null,
        };
    },
    methods: {
        addItem() {
            if (!this.title) {
                return;
            }

            this.alert.saving(this.$t('Vraag toevoegen'), this.$t('assignment.multiple_choice_being_added'));

            const data = {
                part_id: this.partIn.id,
                type: this.partIn.sub_type === 5 ? 1 : this.partIn.sub_type === 6 ? 2 : 3,
                value: this.title,
            };

            this.axios.post(this.routes.assignmentPartListItemAdd(this.partIn.id), data).then(
                (response) => {
                    this.$emit('list-item-added', response.data);
                    this.alert.success();
                    this.title = '';
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.new-list-question {
    margin-bottom: 0;

    input {
        border-top: 1px solid $border-color;
        border-left: 1px solid $border-color;
        border-bottom: 1px solid $border-color;
        height: 38px;
        padding: map-get($grid-gutter-spacing, 'ten');
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;

        &:focus {
            outline: none;
            box-shadow: none;
        }
    }

    .btn-add-list-question {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;

        &:before {
            margin-right: 0;
        }
    }

    &:focus-within {
        border-radius: 4px;
        box-shadow: 0 0 0 0.2rem rgba($primary, 0.25);
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .new-question {
        width: auto;
        max-width: 100%;
    }
}
</style>
